<template>
    <DetailsSection class="step">
        <template slot="header">
            <media-only desktop>
                <span class="step-number">
                </span>
            </media-only>
            {{$t('Cancellation.header.scope')}}
        </template>

        <translate path="Cancellation.scope.text" tag="p" :params="{ amount: numberOfVoucherCodes }">
            <template v-slot:break>
                <br />
            </template>
        </translate>

        <div>
            <div class="custom-control custom-radio mb-2">
                <input type="radio" id="scope1" v-model="scopeValue" value="true" class="custom-control-input">
                <label class="custom-control-label" for="scope1">
                    {{$t('Cancellation.scope.cancelEntireOption')}}
                </label>
            </div>

            <div class="custom-control custom-radio">
                <input type="radio" id="scope2" v-model="scopeValue" value="false" class="custom-control-input">
                <label for="scope2" class="custom-control-label">
                    {{$t('Cancellation.scope.cancelMentionedOption')}}
                </label>
            </div>
        </div>
    </DetailsSection>
</template>

<script>
    import DetailsSection from '@/components/DetailsSection';

    export default {
        name: 'CancellationScope',
        components: {
            DetailsSection
        },
        props: {
            numberOfVoucherCodes: Number,
            cancelCompleteOrder: Boolean
        },
        computed: {
            scopeValue: {
                get() {
                    return this.cancelCompleteOrder === true
                        ? "true"
                        : this.cancelCompleteOrder === false ? "false" : null;
                },
                set(value) {
                    this.$emit('update:cancelCompleteOrder', value === "true");
                }
            }
        }
    }
</script>

<style scoped>

</style>
